import { Measure } from 'services/model/model.service';
import { IntlShape, useIntl } from 'react-intl';
import { InterpretationValue } from 'models/measureInterpretation';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';

export interface CustomMeasureDefinition<T extends CustomMeasureProvider> {
  code: keyof T;
  translationId: string;
  unitCode: MeasureUnitCode;
  interpretation: InterpretationValue;
}

export type CustomMeasureProvider = Record<string, Measure>;

export const defToMeasure = <T extends CustomMeasureProvider>(
  definition: CustomMeasureDefinition<T>,
  intl: IntlShape
): Measure => {
  return {
    code: definition.code as string,
    getValue: values => (values ? (values[definition.code as string] ?? 0) : 0),
    longName: intl.formatMessage({ id: definition.translationId }),
    metric: {
      code: definition.code as string,
      name: intl.formatMessage({ id: definition.translationId }),
      translationId: definition.translationId,
      unit: definition.unitCode,
      interpretation: definition.interpretation,
    },
  };
};

export const useCustomMeasure = <T extends CustomMeasureProvider>(
  definitions: CustomMeasureDefinition<T>[]
): Measure[] => {
  const intl = useIntl();

  return definitions.map(def => defToMeasure(def, intl));
};
